import { render, staticRenderFns } from "./OnboardingCard.vue?vue&type=template&id=2de58b18&scoped=true"
import script from "./OnboardingCard.vue?vue&type=script&lang=js"
export * from "./OnboardingCard.vue?vue&type=script&lang=js"
import style0 from "./OnboardingCard.vue?vue&type=style&index=0&id=2de58b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de58b18",
  null
  
)

export default component.exports